<div class="athlete-answer">
    <h3 class="question-title">{{ data[0].questionTitle }}</h3>
    <div class="human">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayout.lt-sm="column" fxLayoutGap="20px">
            <div fxFlex.sm="50">
              <svg id="human-front" [attr.viewBox]="'0 0 137 400'" [attr.height]="400">
                <ng-container *ngFor="let path of frontPaths">
                  <path [attr.stroke-width]="path.borderSize ?? 0"
                        [attr.stroke]="path.borderColor ?? ''"
                        [attr.fill]="path.fill ?? ''"
                        [attr.d]="path.path"
                        [attr.class]="'path'"
                        (click)="showDialog(path)">
                  </path>
                </ng-container>
              </svg>
            </div>
            <div fxFlex.sm="50">
              <svg id="human-back" [attr.viewBox]="'0 0 137 400'" [attr.height]="400">
                <ng-container *ngFor="let path of backPaths">
                  <path [attr.stroke-width]="path.borderSize ?? 0"
                        [attr.stroke]="path.borderColor ?? ''"
                        [attr.fill]="path.fill ?? ''"
                        [attr.d]="path.path"
                        [attr.class]="'path'"
                        (click)="showDialog(path)">
                  </path>
                </ng-container>
              </svg>
            </div>
        </div>
    </div>
</div>
